import React, { lazy } from 'react';
import { Navigate } from 'react-router-dom';

// Layout
import AuthenticatedLayout from './layouts/AuthenticatedLayout';
import { useAuth } from './contexts/AuthContext';
import FeatureRoute from './components/FeatureRoute';
// import SalesmanLiveTracking from './pages/Route/Live_Sales_Tracking/Salesman_live_tracking';

const RouteAssignList = lazy(() => import('./pages/Route/route_assign/RouteAssignList'));
const AddRouteAssign = lazy(() => import('./pages/Route/route_assign/AddRouteAssign'));
const EditRouteAssign = lazy(() => import('./pages/Route/route_assign/EditRouteAssign'));
const RouteAssignDetails = lazy(() => import('./pages/Route/route_assign/RouteAssignDetails'));
const CreateDebitNotes = lazy(() => import('./pages/Accounts/Debit Notes/CreateDebitNotes'));
const RouteHistoryList = lazy(() => import('./pages/Route/Route_history/RouteHistoryList'));
const RouteHistoryDetail = lazy(() => import('./pages/Route/Route_history/RouteHistoryDetail'));
const ViewRoutePage = lazy(() => import('./pages/Route/route_manage/RouteDetails'));
const PlanConfigure = lazy(() => import('./pages/Plan_configure/PlanConfig'));
const PricingPage = lazy(() => import('./pages/Plan_configure/subscriptions'));
const PlanCustomize = lazy(() => import('./pages/Plan_configure/PlanCustomize'));
const StripeSuccess = lazy(() => import('./pages/Plan_configure/StripeSuccess'));
const GoodsReceiptCreate = lazy(() => import('./pages/Purchases/Goods Reciept/GoodsReceiptCreate'));

const RouteList = lazy(() => import('./pages/Route/route_manage/RouteList'));
const AddRoutePage = lazy(() => import('./pages/Route/route_manage/addRoute'));
const EditRoutePage = lazy(() => import('./pages/Route/route_manage/editRoute'));

const SalesmanLiveTracking = lazy(() => import('./pages/Route/Live_Sales_Tracking/SalesmanLiveTracking'));


const WhatsappConfiguration = lazy(() => import('./pages/whatsapp/configuration/WhatsappConfiguration'));
const WhatsappConfigurationAdd = lazy(() => import('./pages/whatsapp/configuration/AddWhatsappConfig'));
const WhatsappConfigurationEdit = lazy(() => import('./pages/whatsapp/configuration/EditWhatsappConfig'));
const WhatsappConfigurationDetails = lazy(() => import('./pages/whatsapp/configuration/DetailsWhatsappConfig'));
const WhatsappTemplate = lazy(() => import('./pages/whatsapp/templates/whatsappTemplate'));
const AddWhatsappTemplate = lazy(() => import('./pages/whatsapp/templates/AddWhatsappTemplate'));
const WhatsappTemplateDetails = lazy(() => import('./pages/whatsapp/templates/WhatsappTemplateDetails'));
const WhatsappTemplateEdit = lazy(() => import('./pages/whatsapp/templates/EditWhatsappTemplate'));
const MessageHistory = lazy(() => import('./pages/whatsapp/message history/whatsappMsgHistory'));



const CurrentStock = lazy(() => import('./pages/Stock/current_stock/CurrentStock'));
const TotalStock = lazy(() => import('./pages/Stock/current_stock/TotalStock'));
const Transfers = lazy(() => import('./pages/Stock/transfers/transfers'));
const AddTransfers = lazy(() => import('./pages/Stock/transfers/add_transfers'));
const TransferDetails = lazy(() => import('./pages/Stock/transfers/transferDetails'));
const EditTransfers = lazy(() => import('./pages/Stock/transfers/EditTransfers'));
const InventoryAdjustments = lazy(() => import('./pages/Stock/inventory_adjustments/inventory_adjustments'));
const AddInventoryAdjustments = lazy(() => import('./pages/Stock/inventory_adjustments/add_inventory_adjustments'));
const InventoryAdjustmentsDetails = lazy(() => import('./pages/Stock/inventory_adjustments/AdjustmentDetails'));
const EditInventoryAdjustments = lazy(() => import('./pages/Stock/inventory_adjustments/EditAdjustments'));
const InventorySettings = lazy(() => import('./pages/Inventory/Settings/InventorySettings'));





// 🔐 Auth
const LoginNew = lazy(() => import('./pages/Login/Login-new'));
const PasswordModification = lazy(() => import('./pages/Login/ResetPassword'));
const Registration = lazy(() => import('./pages/Login/Registration'));
const Home = lazy(() => import('./pages/Login/Home'));
const DeactivatedAccountPopup = lazy(() => import('./pages/Login/DeactivatedAccountPopup'));

// 📊 Dashboard
const Dashboard = lazy(() => import('./pages/dashboard/dashboard'));

// 📦 Products
const Products = lazy(() => import('./pages/products/Products/products'));
const AddProducts = lazy(() => import('./pages/products/Products/add_products'));
const EditProducts = lazy(() => import('./pages/products/Products/EditProducts'));
const ProductsDetails = lazy(() => import('./pages/products/Products/ProductsDetails'));

const ProductVariants = lazy(() => import('./pages/products/Variants/variants'));
const AddVariants = lazy(() => import('./pages/products/Variants/AddVariants'));
const EditVariants = lazy(() => import('./pages/products/Variants/EditVariants'));
const VariantsDetails = lazy(() => import('./pages/products/Variants/VariantsDetails'));

const ProductCategory = lazy(() => import('./pages/products/category/CategoryList'));
const ProductAddCategory = lazy(() => import('./pages/products/category/add_product_cat'));
const ProductEditCategory = lazy(() => import('./pages/products/category/EditProductCat'));
const ProductCategoryDetails = lazy(() => import('./pages/products/category/CategoryDetails'));

const Attributes = lazy(() => import('./pages/products/Attributes/AttributeList'));
const AddProductAttributes = lazy(() => import('./pages/products/Attributes/AddProductAttribute'));
const EditProductAttributes = lazy(() => import('./pages/products/Attributes/EditProductAttribute'));
const ProductAttributesDetails = lazy(() => import('./pages/products/Attributes/AttributesDetails'));

// 📐 UOM
const UomSub = lazy(() => import('./pages/uoms/uoms/uoms'));
const UomCategory = lazy(() => import('./pages/uoms/uom_categories/UomCategory'));
const UomAdd = lazy(() => import('./pages/uoms/uoms/uomAdd'));
const UomEdit = lazy(() => import('./pages/uoms/uoms/UomEdit'));
const UomDetails = lazy(() => import('./pages/uoms/uoms/UomDetails'));


// Physical Warehouses
const PhysicalWarehouses = lazy(() => import('./pages/warehouses/physical/PhysicalWarehouse'));
const AddPhysicalWarehouse = lazy(() => import('./pages/warehouses/physical/AddPhysicalWarehouse'));
const EditPhysicalWarehouse = lazy(() => import("./pages/warehouses/physical/EditPhysicalWarehouse"));
const DetailsPhysicalWarehouse = lazy(() => import("./pages/warehouses/physical/DetailsPhysicalWarehouse"));

// Mobile Warehouses
const MobileWarehouse = lazy(() => import("./pages/warehouses/mobile/MobileWarehouse"));
const AddMobileWarehouse = lazy(() => import("./pages/warehouses/mobile/AddMobileWarehouse"));
const EditMobileWarehouse = lazy(() => import("./pages/warehouses/mobile/EditMobileWarehouse"));
const DetailsMobileWarehouse = lazy(() => import("./pages/warehouses/mobile/DetailsMobileWarehouse"));

// 🚚 Vehicle
const VehicleList = lazy(() => import('./pages/Vehicle/vehicles/vehicleList'));
const AddVehicles = lazy(() => import('./pages/Vehicle/vehicles/AddVehicle'));
const EditVehicles = lazy(() => import('./pages/Vehicle/vehicles/EditVehicle'));
const VehicleDetails = lazy(() => import('./pages/Vehicle/vehicles/VehicleDetails'));

const MaintenanceList = lazy(() => import('./pages/Vehicle/maintenance/maintenancelist'));
const AddMaintenance = lazy(() => import('./pages/Vehicle/maintenance/AddMaintenance'));
const EditMaintenance = lazy(() => import('./pages/Vehicle/maintenance/EditMaintenance'));
const MaintenanceDetails = lazy(() => import('./pages/Vehicle/maintenance/MaintenanceDetails'));

const Penalties = lazy(() => import('./pages/Vehicle/Penalties/Penalties'));
const AddPenalties = lazy(() => import('./pages/Vehicle/Penalties/AddPenalty'));
const EditPenalties = lazy(() => import('./pages/Vehicle/Penalties/EditPenalty'));
const PenaltyDetails = lazy(() => import('./pages/Vehicle/Penalties/PenaltyDetails'));

const DriverList = lazy(() => import('./pages/Vehicle/drivers/DriverList'));
const AddDriver = lazy(() => import('./pages/Vehicle/drivers/AddDriver'));
const EditDriver = lazy(() => import('./pages/Vehicle/drivers/EditDriver'));
const DriverDetails = lazy(() => import('./pages/Vehicle/drivers/DriverDetails'));

const VehicleType = lazy(() => import('./pages/Vehicle/Vehicle Type/VehicleType'));

// 💰 Expenses
const ExpenseList = lazy(() => import('./pages/Expenses/ExpenseList'));
const AddExpense = lazy(() => import('./pages/Expenses/ExpenseAdd'));
const EditExpense = lazy(() => import('./pages/Expenses/ExpenseEdit'));
const ExpenseDetails = lazy(() => import('./pages/Expenses/ExpenseDetail'));
const ExpCategory = lazy(() => import('./pages/Expenses/ExpenseCategory'));
const AddExpenseCategory = lazy(() => import('./pages/Expenses/ExpenseCategoryAdd'));
const EditExpenseCategory = lazy(() => import('./pages/Expenses/ExpenseCategoryEdit'));
const ExpenseCategoryDetails = lazy(() => import('./pages/Expenses/ExpenseCategoryDetail.jsx'));


// Commission Plans
const CommissionList = lazy(() => import('./pages/CommissionPlans/Incentives/CommissionList'));
const AddCommission = lazy(() => import('./pages/CommissionPlans/Incentives/AddCommission'));
const CommissionRescords = lazy(() => import('./pages/CommissionPlans/IncentiveReports/CommissionRecords'));
const EditCommission = lazy(() => import('./pages/CommissionPlans/Incentives/EditCommission'))
const Commission = lazy(() => import('./pages/CommissionPlans/Incentives/Commission'))



// 📈 Sales

const SalesQuotation = lazy(() => import('./pages/Sales/Quotations/Quotation'));
const QuotationsDetails = lazy(() => import('./pages/Sales/Quotations/QuotationsDetails'));
const AddQuotation = lazy(() => import('./pages/Sales/Quotations/AddQuotations'));
const EditQuotation = lazy(() => import('./pages/Sales/Quotations/EditQuotations'));
const SendMail = lazy(() => import('./components/common/SendMail/SendMail'));

const SalesOrder = lazy(() => import('./pages/Sales/SalesOrder/SalesOrder'));
const AddSalesOrder = lazy(() => import('./pages/Sales/SalesOrder/AddSalesOrder'));
const EditSalesOrder = lazy(() => import('./pages/Sales/SalesOrder/EditSalesOrder'));
const SalesOrderDetail = lazy(() => import('./pages/Sales/SalesOrder/DetailSalesOrder'));

const Customers = lazy(() => import('./pages/Sales/Customers/Customers'));
const AddCustomers = lazy(() => import('./pages/Sales/Customers/AddCustomer'));
const EditCustomers = lazy(() => import('./pages/Sales/Customers/EditCustomer'));
const CustomerDetails = lazy(() => import('./pages/Sales/Customers/CustomerDetails'));
const CustomerStatement = lazy(() => import('./pages/Sales/Customers/CustomerStatement'));
const VendorStatement = lazy(() => import('./pages/Purchases/Vendors/VendorStatement'));

const SalesReturn = lazy(() => import('./pages/Sales/SalesReturn/SalesReturn'));
const AddSalesReturn = lazy(() => import('./pages/Sales/SalesReturn/AddSalesReturn'));
const EditSalesReturn = lazy(() => import('./pages/Sales/SalesReturn/EditSalesReturn'));
const SalesReturnDetails = lazy(() => import('./pages/Sales/SalesReturn/SalesReturnDetails'));

const ReturnReceipt = lazy(() => import('./pages/Sales/SalesReturn/ReturnReceipt'));
const AddReturnReceipt = lazy(() => import('./pages/Sales/SalesReturn/AddReturnReceipt'));
const ReturnReceiptDetails = lazy(() => import('./pages/Sales/SalesReturn/ReturnReceiptDetails'));

const Contacts = lazy(() => import('./pages/Sales/Contacts/Contact'));
const Pricelists = lazy(() => import('./pages/Sales/Pricelists/Pricelist'));
const AddPricelist = lazy(() => import('./pages/Sales/Pricelists/AddPricelist'));
const EditPricelist = lazy(() => import('./pages/Sales/Pricelists/EditPricelist'));
const PricelistDetails = lazy(() => import('./pages/Sales/Pricelists/DetailsPricelist'));

const DeliveryOrders = lazy(() => import('./pages/Sales/DeliveryOrder/DeliveryOrder'));
const DeliveryOrderDetails = lazy(() => import('./pages/Sales/DeliveryOrder/DeliveryOrderDetails'));

// 🧾 Accounts
const Invoices = lazy(() => import('./pages/Accounts/invoices/Invoices'));
const CreateInvoices = lazy(() => import('./pages/Accounts/invoices/CreateInvoice'));
const InvoiceDetails = lazy(() => import('./pages/Accounts/invoices/InvoiceDetails'));
const InvoiceTemplate = lazy(() => import('./pages/Accounts/invoices/InvoiceTemplate'));
const EInvoiceTemplate = lazy(() => import('./pages/Accounts/invoices/EInvoiceTemplate'));
const InvoiceExportTemplate = lazy(() => import('./pages/Accounts/invoices/InvoiceExportTemplate'));

const QatarInvoiceTemplate = lazy(() => import('./pages/Accounts/invoices/QatarInvoice'));
const QuotationTemplate = lazy(() => import('./pages/Accounts/invoices/QuotationTemplate'));
const ProformaInvoiceTemplate = lazy(() => import('./pages/Accounts/invoices/ProformaInvoiceTemplate'));
const SaleorderTemplate = lazy(() => import('./pages/Accounts/invoices/SaleorderTemplate'));
const SaudiInvoiceTemplate = lazy(() => import('./pages/Accounts/invoices/SaudiInvoice'));
const SaudiEInvoiceTemplate = lazy(() => import('./pages/Accounts/invoices/SaudiEInvoice'));
const QuotationArabicTemplate = lazy(() => import('./pages/Accounts/invoices/QuotationArabicTemplate'));
const RFQTemplate = lazy(() => import('./pages/Accounts/invoices/RFQTemplate'));
const PurchaseOrderTemplate = lazy(() => import('./pages/Accounts/invoices/PurchaseOrderTemplate'));
const NotificationPage = lazy(() => import('./pages/Accounts/Notification/NotificationPage'));
const PaymentTemplate = lazy(() => import('./pages/Accounts/Payments/PaymentReceiptTemplate'));



const CreditNote = lazy(() => import('./pages/Accounts/credit note/CreditNote'));
const CreateCreditNote = lazy(() => import('./pages/Accounts/credit note/CreateCreditNote'));
const CreateCreditNoteDetails = lazy(() => import('./pages/Accounts/credit note/CreditNoteDetails'));
const SaudiECreditNote = lazy(() => import('./pages/Accounts/credit note/SaudiECreditNote'));


const ChartofAccounts = lazy(() => import('./pages/Accounts/Configuration/ChartAccounts/ChartOfAccnt'))
const AddChartOfAccounts = lazy(() => import('./pages/Accounts/Configuration/ChartAccounts/AddChartOfAccount'));
const EditChartOfAccounts = lazy(() => import('./pages/Accounts/Configuration/ChartAccounts/EditChartOfAccount'));
const DetailChartOfAccounts = lazy(() => import('./pages/Accounts/Configuration/ChartAccounts/DetailChartOfAccount'));


const Currency = lazy(() => import('./pages/Accounts/Configuration/Currency/Currency'));
const AddCurrency = lazy(() => import('./pages/Accounts/Configuration/Currency/AddCurrency'));
const EditCurrency = lazy(() => import('./pages/Accounts/Configuration/Currency/EditCurrency'));
const CurrencyDetails = lazy(() => import('./pages/Accounts/Configuration/Currency/CurrencyDetails'));

const Journals = lazy(() => import('./pages/Accounts/Configuration/Journals/Journals'));
const AddJournals = lazy(() => import('./pages/Accounts/Configuration/Journals/AddJournals'));
const EditJournals = lazy(() => import('./pages/Accounts/Configuration/Journals/EditJournals'));
const DetailJournals = lazy(() => import('./pages/Accounts/Configuration/Journals/DetailJournals'));


const Taxes = lazy(() => import('./pages/Accounts/Configuration/Taxes/Taxes'));
const AddTax = lazy(() => import('./pages/Accounts/Configuration/Taxes/TaxAdd'));
const EditTax = lazy(() => import('./pages/Accounts/Configuration/Taxes/TaxEdit'));
const DetailTax = lazy(() => import('./pages/Accounts/Configuration/Taxes/TaxDetail'));
const AccountingSettings = lazy(() => import('./pages/Accounts/Configuration/AccountingSettings/AccountingSettingsDetail'));
const EditAccountingSettings = lazy(() => import('./pages/Accounts/Configuration/AccountingSettings/AccountingSettingsEdit'));
const FinancialYearLock = lazy(() => import('./pages/Accounts/FinancialYear/FinancialYearLock/FinancialYearLock'));

const CustomerPayment = lazy(() => import('./pages/Accounts/CustomerPayment/CustomerPayment'));
const AddCustomerPayment = lazy(() => import('./pages/Accounts/CustomerPayment/AddCustomerPayment'));
const CustomerPaymentDetails = lazy(() => import('./pages/Accounts/CustomerPayment/CustomerPaymentDetails'));

const JournalEntries = lazy(() => import('./pages/Accounts/Journal Entries/JournalEntries'));
const AddJournalEntries = lazy(() => import('./pages/Accounts/Journal Entries/AddJournalEntries'));
const EditJournalEntries = lazy(() => import('./pages/Accounts/Journal Entries/EditJournalEntries'));
const DetailJournalEntries = lazy(() => import('./pages/Accounts/Journal Entries/DetailJournalEntries'));
const Reports = lazy(() => import('./pages/Accounts/Reports/Reports'));
const TrialBalance = lazy(() => import('./pages/Accounts/Reports/TrialBalance'));
const SalesByCustomer = lazy(() => import('./pages/Accounts/Reports/SalesByCustomer'));
const SalesByCustomerDetail = lazy(() => import('./pages/Accounts/Reports/SalesByCustomerDetail'));
const SalesByItem = lazy(() => import('./pages/Accounts/Reports/SalesByItem'));
const SalesByItemDetail = lazy(() => import('./pages/Accounts/Reports/SalesByItemDetail'));
const SalesSummary = lazy(() => import('./pages/Accounts/Reports/SalesSummary'));
const SalesBySalesPerson = lazy(() => import('./pages/Accounts/Reports/SalesBySalesPerson'));
const SalesBySalesPersonDetail = lazy(() => import('./pages/Accounts/Reports/SalesBySalesPersonDetail'));
const ProfitByItem = lazy(() => import('./pages/Accounts/Reports/ProfitByItem'));
const CustomerOutstanding = lazy(() => import('./pages/Accounts/Reports/CustomerOutstanding'));
const CollectionReport = lazy(() => import('./pages/Accounts/Reports/CollectionReport'));
const IncentiveReport = lazy(() => import('./pages/Accounts/Reports/IncentiveReport'));
const TargetVsAchievementsReport = lazy(() => import('./pages/Accounts/Reports/TargetVsAchievementsReport'));
const RouteWiseReport = lazy(() => import('./pages/Accounts/Reports/RouteWiseReport'));
const GeneralLedgers = lazy(() => import('./pages/Accounts/GeneralLedgers/GeneralLedgers'));
const AccountLedgers = lazy(() => import('./pages/Accounts/GeneralLedgers/AccountLedgers'));
const AgedReceivable = lazy(() => import('./pages/Accounts/Reports/AgedReceivable'));
const AgedPayable = lazy(() => import('./pages/Accounts/Reports/AgedPayable'));
const AgedReceivablesDetail = lazy(() => import('./pages/Accounts/Reports/AgedReceivablesDetail'));
const AgedPayablesDetail = lazy(() => import('./pages/Accounts/Reports/AgedpayablesDetail'));
const ProfitAndLoss = lazy(() => import('./pages/Accounts/Reports/ProfitAndLoss'));
const BalanceSheet = lazy(() => import('./pages/Accounts/Reports/BalanceSheet'));
const Refunds = lazy(() => import('./pages/Accounts/Debit Notes/DebitNotes'));
const RefundDetails = lazy(() => import('./pages/Accounts/Debit Notes/DebitNotesDetails'));
const PurchasesByItem = lazy(() => import('./pages/Accounts/Reports/PurchaseByItem'));
const PurchasesByVendor = lazy(() => import('./pages/Accounts/Reports/PurchaseByVendor'));
const PurchasesByItemDetail = lazy(() => import('./pages/Accounts/Reports/PurchasesByItemDetail'));
const PurchasesByVendorDetail = lazy(() => import('./pages/Accounts/Reports/PurchasesByVendorDetail'));
const TaxSummaryReport = lazy(() => import('./pages/Accounts/Reports/TaxSummaryReport'));
const TaxSummaryReportDetail = lazy(() => import('./pages/Accounts/Reports/TaxSummaryReportDetail'));
const InventoryValuationSummaryReport = lazy(() => import('./pages/Accounts/Reports/InventoryValuationSummaryReport'));
const InventoryValuationSummaryDetailReport = lazy(() => import('./pages/Accounts/Reports/InventoryValuationSummaryDetailReport'));
const StockSummaryReport = lazy(() => import('./pages/Accounts/Reports/StockSummaryReport'));
const InventoryDetailSummaryReport = lazy(() => import('./pages/Accounts/Reports/InventorySummaryReport'));
const StockMovementReport = lazy(() => import('./pages/Accounts/Reports/StockMovementReport'));
const InventoryAdjustmentReport = lazy(() => import('./pages/Accounts/Reports/InventoryAdjustmentReport'));
const ActivityLogAuditTrailReport = lazy(() => import('./pages/Accounts/Reports/ActivityLogAuditTrailReport'));


const VendorBills = lazy(() => import('./pages/Accounts/Vendor bills/VendorBills'));
const CreateVendorBills = lazy(() => import('./pages/Accounts/Vendor bills/CreateVendorBills'));
const VendorBillDetails = lazy(() => import('./pages/Accounts/Vendor bills/VendorBillDetails'));


const VendorPayments = lazy(() => import('./pages/Accounts/Vendor payments/VendorPayment'));
const VendorPaymentDetails = lazy(() => import('./pages/Accounts/Vendor payments/VendorPaymentsDetails'));
const AddVendorPayment = lazy(() => import('./pages/Accounts/Vendor payments/AddVendorPayment'));

// ⚙️ Settings, Roles, Users
const MyProfile = lazy(() => import('./pages/MyProfile/MyProfile'));
const MyProfileEdit = lazy(() => import('./pages/MyProfile/MyProfileEdit'));
const MyOrganization = lazy(() => import('./pages/MyOrg/MyOrg'));
const EditMyOrganization = lazy(() => import('./pages/MyOrg/EditMyOrg'));
const OrganizationDetails = lazy(() => import('./pages/Organization/OrganizationDetails'));
const OrganizationEdit = lazy(() => import('./pages/Organization/OrganizationEdit'));

const UserAccounts = lazy(() => import('./pages/UserAccounts/UserAcnt/UserAccount'));
const AddUsers = lazy(() => import('./pages/UserAccounts/UserAcnt/AddUsers'));
const EditUserAccount = lazy(() => import('./pages/UserAccounts/UserAcnt/UserAccountEdit'));
const DetailsUserAccount = lazy(() => import('./pages/UserAccounts/UserAcnt/DetailsUserAccnt'));

const UserRoles = lazy(() => import('./pages/UserAccounts/UserRole/UserRole'));
const UserRoleDetails = lazy(() => import('./pages/UserAccounts/UserRole/UserRoleDetails'));
const UserRoleAdd = lazy(() => import('./pages/UserAccounts/UserRole/AddUserRole'));
const UserRoleEdit = lazy(() => import('./pages/UserAccounts/UserRole/EditUserRole'));

const PrefixNumbering = lazy(() => import('./pages/Settings/Prefix&Numbering/PrefixNumbering'));

// 🚧 Other Pages
const ComingSoon = lazy(() => import('./pages/UnderConstruction/ComingSoon'));
const NoPermission = lazy(() => import('./pages/UnderConstruction/NoPermission'));


// 🛒 Purchase
const PurchaseRFQ = lazy(() => import('./pages/Purchases/RFQ/PurchaseRFQ'));
const RFQDetails = lazy(() => import('./pages/Purchases/RFQ/RFQDetails'));
const RFQAdd = lazy(() => import('./pages/Purchases/RFQ/AddRfq'));
const EditRfq = lazy(() => import('./pages/Purchases/RFQ/EditRfq'));


const Purchase = lazy(() => import('./pages/Purchases/Purchase/PurchaseList'));
const PurchaseAdd = lazy(() => import('./pages/Purchases/Purchase/PurchaseAdd'));
const PurchaseEdit = lazy(() => import('./pages/Purchases/Purchase/PurchaseEdit'));
const PurchaseDetails = lazy(() => import('./pages/Purchases/Purchase/PurchaseDetails'));

const PurchaseReturn = lazy(() => import('./pages/Purchases/PurchaseReturn/PurchaseReturnList'));
const AddPurchaseReturn = lazy(() => import('./pages/Purchases/PurchaseReturn/AddPurchaseReturn'));
const EditPurchaseReturn = lazy(() => import('./pages/Purchases/PurchaseReturn/EditPurchaseReturn'));
const PurchaseReturnDetails = lazy(() => import('./pages/Purchases/PurchaseReturn/PurchaseReturnDetails'));

const GoodsReturns = lazy(() => import('./pages/Purchases/GoodsReturn/GoodsReturn'));
const AddGoodsReturn = lazy(() => import('./pages/Purchases/GoodsReturn/AddGoodsReturn'));
const GoodsReturnDetails = lazy(() => import('./pages/Purchases/GoodsReturn/GoodsReturnDetails'));


const GoodsReceipts = lazy(() => import('./pages/Purchases/Goods Reciept/GoodsReciept'));
const GoodsReceiptDetails = lazy(() => import('./pages/Purchases/Goods Reciept/GoodsReceiptDetails'));
const GoodsReceiptEdit = lazy(() => import('./pages/Purchases/Goods Reciept/GoodsReceiptEdit'));
// const CreatePartialGoodsReceipt = lazy(() => import('./pages/Purchases/Goods Reciept/CreatePartialGoodsReceipt'));


const Vendors = lazy(() => import('./pages/Purchases/Vendors/VendorsList'));
const VendorsAdd = lazy(() => import('./pages/Purchases/Vendors/AddVendors'));
const VendorsEdit = lazy(() => import('./pages/Purchases/Vendors/EditVendors'));
const VendorDetails = lazy(() => import('./pages/Purchases/Vendors/VendorsDetails'));
const BatchTracking = lazy(() => import('./pages/Purchases/BatchTracking/BatchTracking'));
const BatchTrackingDetails = lazy(() => import('./pages/Purchases/BatchTracking/BatchTrackingDetails'));
// const BatchTrackingEdit = lazy(() => import('./pages/Purchases/BatchTracking/BatchTrackingEdit'));


const ImportFirstPage = lazy(() => import('./pages/ImportAndExport/ImportFirstPage'));
const ImportSecondPage = lazy(() => import('./pages/ImportAndExport/ImportSecondPage'));
const ImportThirdPage = lazy(() => import('./pages/ImportAndExport/ImportThirdPage'));
const ImportFourthPage = lazy(() => import('./pages/ImportAndExport/ImportFourthPage'));

function PrivateRoute({ children }) {
  const { isAuthenticated, isAuthChecked } = useAuth();

  if (!isAuthChecked) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

function PublicRoute({ children }) {
  const { isAuthenticated, isAuthChecked } = useAuth();

  if (!isAuthChecked) {
    return <div>Loading...</div>;
  }

  if (isAuthenticated) {
    return <Navigate to="/home" replace />;
  }

  return children;
}

// Routes Configuration
export function createRoutes() {
  return [
    {
      path: '/login',
      element: (
        <PublicRoute>
          <LoginNew />
        </PublicRoute>
      ),
    },
    {
      path: '/password-modification',
      element: (
        <PublicRoute>
          <PasswordModification />
        </PublicRoute>
      ),
    },
    {
      path: '/registration',
      element: (
        <PublicRoute>
          <Registration />
        </PublicRoute>
      ),
    },
    {
      path: '/home',
      element: (
        <Home />
      ),
    },
    {
      path: '/deactivated-account',
      element: (
        <PublicRoute>
          <DeactivatedAccountPopup />
        </PublicRoute>
      ),
    },
    {
      path: '/notifications',
      element: (
        <PrivateRoute>
          <NotificationPage />
        </PrivateRoute>
      ),
    },
    {
      path: '/plan-configure',
      element: (
        <PrivateRoute>
          <PlanConfigure />
        </PrivateRoute>
      ),

    },

    {
      path: 'plans',
      element: (
        <PrivateRoute>
          <PricingPage />
        </PrivateRoute>
      )
    },

    {
      path: 'plan',
      element: (
        <PrivateRoute>
          <PricingPage />
        </PrivateRoute>
      )
    },

    {
      path: '/plan-costomize',
      element: (
        <PrivateRoute>
          <PlanCustomize />
        </PrivateRoute>
      ),

    },

    {
      path: "/payment/stripe/success",
      element: <StripeSuccess />
    },
    {
      path: "/payment/stripe/cancel",
      element: <Navigate to="/plans" />
    },

    {
      path: '/',
      element: (
        <PrivateRoute>
          <AuthenticatedLayout />
        </PrivateRoute>
      ),
      children: [
        // Default redirect for root
        { index: true, element: <Navigate to="/dashboard" replace /> },
        { path: '/dashboard', element: <Dashboard /> },

        // Products Section
        { path: 'inventory/products', element: <Products /> },
        { path: 'inventory/products/add', element: <AddProducts /> },
        { path: 'inventory/products/edit/:id', element: <EditProducts /> },
        { path: 'inventory/products/details/:id', element: <ProductsDetails /> },

        // Variants
        { path: 'inventory/variants', element: <ProductVariants /> },
        { path: 'inventory/variants/add', element: <AddVariants /> },
        { path: 'inventory/variants/edit/:id', element: <EditVariants /> },
        { path: 'inventory/variants/details/:id', element: <VariantsDetails /> },

        // Product Attributes
        { path: 'inventory/product-attributes', element: <Attributes /> },
        { path: 'inventory/product-attributes/add', element: <AddProductAttributes /> },
        { path: 'inventory/product-attributes/edit/:id', element: <EditProductAttributes /> },
        { path: 'inventory/product-attributes/details/:id', element: <ProductAttributesDetails /> },


        { path: 'inventory/product-categories', element: <ProductCategory /> },
        { path: 'inventory/product-categories/add', element: <ProductAddCategory /> },
        { path: 'inventory/product-categories/edit/:id', element: <ProductEditCategory /> },
        { path: 'inventory/product-categories/details/:id', element: <ProductCategoryDetails /> },


        { path: 'inventory/warehouses/physical', element: <PhysicalWarehouses /> },
        { path: 'inventory/warehouses/physical/add', element: <AddPhysicalWarehouse /> },
        { path: 'inventory/warehouses/physical/edit/:id', element: <EditPhysicalWarehouse /> },
        { path: 'inventory/warehouses/physical/details/:id', element: <DetailsPhysicalWarehouse /> },

        { path: 'inventory/warehouses/mobile',             element: <FeatureRoute feature="route_management"><MobileWarehouse /></FeatureRoute> },
        { path: 'inventory/warehouses/mobile/add',         element: <FeatureRoute feature="route_management"><AddMobileWarehouse /></FeatureRoute> },
        { path: 'inventory/warehouses/mobile/edit/:id',    element: <FeatureRoute feature="route_management"><EditMobileWarehouse /></FeatureRoute> },
        { path: 'inventory/warehouses/mobile/details/:id', element: <FeatureRoute feature="route_management"><DetailsMobileWarehouse /></FeatureRoute> },

        { path: 'inventory/stock', element: <CurrentStock /> },
        { path: 'inventory/stock/all', element: <TotalStock /> },

        { path: 'inventory/stock/transfers', element: <Transfers /> },
        { path: 'inventory/stock/transfers/add', element: <AddTransfers /> },
        { path: 'inventory/stock/transfers/details/:id', element: <TransferDetails /> },
        { path: 'inventory/stock/transfers/edit/:id', element: <EditTransfers /> },


        { path: 'inventory/stock/inventory-adjustments', element: <InventoryAdjustments /> },
        { path: 'inventory/stock/inventory-adjustments/add', element: <AddInventoryAdjustments /> },
        { path: 'inventory/stock/inventory-adjustments/details/:id', element: <InventoryAdjustmentsDetails /> },
        { path: 'inventory/stock/inventory-adjustments/edit/:id', element: <EditInventoryAdjustments /> },


        // UOM Section
        { path: 'inventory/uoms', element: <UomSub /> },
        { path: 'inventory/uoms/categories', element: <UomCategory /> },
        { path: 'inventory/uoms/add', element: <UomAdd /> },
        { path: 'inventory/uoms/edit/:id', element: <UomEdit /> },
        { path: 'inventory/uoms/details/:id', element: <UomDetails /> },

        // Inventory Settings
        { path: 'inventory/settings', element: <InventorySettings /> },

        // Commision List
        { path: 'commission-plan/incentives', element: <CommissionList /> },
        { path: 'commission-plan/incentives/add', element: <AddCommission /> },
        { path: 'commission-plan/incentive-reports', element: <CommissionRescords /> },
        { path: 'commission-plan/incentives/update/:id', element: <EditCommission /> },
        { path: 'commission-plan/incentives/details/:id', element: <Commission /> },


        // Vehicle Section
        { path: 'vehicle', element: <VehicleList /> },
        { path: 'vehicle/add', element: <AddVehicles /> },
        { path: 'vehicle/edit/:id', element: <EditVehicles /> },
        { path: 'vehicle/details/:id', element: <VehicleDetails /> },

        { path: 'vehicle/maintenance', element: <MaintenanceList /> },
        { path: 'vehicle/maintenance/add', element: <AddMaintenance /> },
        { path: 'vehicle/maintenance/edit/:id', element: <EditMaintenance /> },
        { path: 'vehicle/maintenance/details/:id', element: <MaintenanceDetails /> },

        { path: 'vehicle/penalties', element: <Penalties /> },
        { path: 'vehicle/penalties/add', element: <AddPenalties /> },
        { path: 'vehicle/penalties/edit/:id', element: <EditPenalties /> },
        { path: 'vehicle/penalties/details/:id', element: <PenaltyDetails /> },

        { path: 'vehicle/drivers', element: <DriverList /> },
        { path: 'vehicle/drivers/add', element: <AddDriver /> },
        { path: 'vehicle/drivers/edit/:id', element: <EditDriver /> },
        { path: 'vehicle/drivers/details/:id', element: <DriverDetails /> },

        { path: 'vehicle/type', element: <VehicleType /> },

        // Expense Section
        { path: 'expenses', element: <ExpenseList /> },
        { path: 'expenses/add', element: <AddExpense /> },
        { path: 'expenses/edit/:id', element: <EditExpense /> },
        { path: 'expenses/details/:id', element: <ExpenseDetails /> },
        { path: 'expenses/category', element: <ExpCategory /> },
        { path: 'expenses/category/add', element: <AddExpenseCategory /> },
        { path: 'expenses/category/edit/:id', element: <EditExpenseCategory /> },
        { path: 'expenses/category/details/:id', element: <ExpenseCategoryDetails /> },
        

        // Sales Section

        { path: 'sales/quotation', element: <SalesQuotation /> },
        { path: 'sales/quotation/details/:id', element: <QuotationsDetails /> },
        { path: 'sales/quotation/add', element: <AddQuotation /> },
        { path: 'sales/quotation/edit/:id', element: <EditQuotation /> },
        { path: 'send-mail/:type/:id', element: <SendMail /> },

        { path: 'sales', element: <SalesOrder /> },
        { path: 'sales/add', element: <AddSalesOrder /> },
        { path: 'sales/edit/:id', element: <EditSalesOrder /> },
        { path: 'sales/details/:id', element: <SalesOrderDetail /> },

        { path: 'sales/customers', element: <Customers /> },
        { path: 'sales/customers/add', element: <AddCustomers /> },
        { path: 'sales/customers/edit/:id', element: <EditCustomers /> },
        { path: 'sales/customers/details/:id', element: <CustomerDetails /> },
        { path: 'sales/customer/statement/:id', element: <CustomerStatement /> },

        { path: 'sales/return', element: <SalesReturn /> },
        { path: 'sales/return/add', element: <AddSalesReturn /> },
        { path: 'sales/return/edit/:id', element: <EditSalesReturn /> },
        { path: 'sales/return/details/:id', element: <SalesReturnDetails /> },

        { path: 'sales/return-receipt', element: <ReturnReceipt /> },
        { path: 'sales/return-receipt/create', element: <AddReturnReceipt /> },
        { path: 'sales/return-receipt/details/:id', element: <ReturnReceiptDetails /> },
        { path: 'sales/contacts', element: <Contacts /> },

        { path: 'sales/pricelist', element: <Pricelists /> },
        { path: 'sales/pricelist/add', element: <AddPricelist /> },
        { path: 'sales/pricelist/edit/:id', element: <EditPricelist /> },
        { path: 'sales/pricelist/details/:id', element: <PricelistDetails /> },

        { path: 'sales/delivery-orders', element: <DeliveryOrders /> },
        { path: 'sales/delivery-orders/details/:id', element: <DeliveryOrderDetails /> },


        // Purchase Section

        { path: 'purchase/rfq', element: <PurchaseRFQ /> },
        { path: 'purchase/rfq/add', element: <RFQAdd /> },
        { path: 'purchase/rfq/edit/:id', element: <EditRfq /> },
        { path: 'purchase/rfq/details/:id', element: <RFQDetails /> },

        { path: 'purchase', element: <Purchase /> },
        { path: 'purchase/add', element: <PurchaseAdd /> },
        { path: 'purchase/edit/:id', element: <PurchaseEdit /> },
        { path: 'purchase/details/:id', element: <PurchaseDetails /> },

        { path: 'purchase/return', element: <PurchaseReturn /> },
        { path: 'purchase/return/add', element: <AddPurchaseReturn /> },
        { path: 'purchase/return/edit/:id', element: <EditPurchaseReturn /> },
        { path: 'purchase/return/details/:id', element: <PurchaseReturnDetails /> },

        { path: 'purchase/vendors', element: <Vendors /> },
        { path: 'purchase/vendors/add', element: <VendorsAdd /> },
        { path: 'purchase/vendors/edit/:id', element: <VendorsEdit /> },
        { path: 'purchase/vendors/details/:id', element: <VendorDetails /> },
        { path: 'purchase/vendor/statement/:id', element: <VendorStatement /> },

        { path: 'purchase/goods-receipt', element: <GoodsReceipts /> },
        { path: 'purchase/goods-receipt/details/:id', element: <GoodsReceiptDetails /> },
        { path: 'purchase/goods-receipt/edit/:id', element: <GoodsReceiptEdit /> },
        { path: 'purchase/goods-receipt/create', element: <GoodsReceiptCreate/> },

        { path: 'purchase/goods-return', element: <GoodsReturns /> },
        { path: 'purchase/goods-return/create', element: <AddGoodsReturn /> },
        { path: 'batch-tracking', element: <BatchTracking /> },
        { path: 'batch-tracking/view/:uuid', element: <BatchTrackingDetails /> },
        { path: 'purchase/batch-tracking', element: <BatchTracking /> },
        { path: 'purchase/batch-tracking/view/:uuid', element: <BatchTrackingDetails /> },
        // { path: 'purchase/batch-tracking/edit/:uuid', element: <BatchTrackingEdit /> },


        // Accounts Section
        { path: 'accounts/invoices', element: <Invoices /> },
        { path: 'accounts/invoices/create', element: <CreateInvoices /> },
        { path: 'accounts/invoices/details/:id', element: <InvoiceDetails /> },
        { path: 'accounts/invoices/print/:id', element: <InvoiceTemplate /> },
        { path: 'accounts/export-invoices/print/:id', element: <InvoiceExportTemplate /> },
        { path: 'accounts/quotation/print/:id', element: <QuotationTemplate /> },
        { path: 'sales/quotation/proforma-invoice/print/:id', element: <ProformaInvoiceTemplate /> },
        { path: 'accounts/proforma-invoice/print/:id', element: <ProformaInvoiceTemplate /> },
        { path: 'accounts/saleorder/print/:id', element: <SaleorderTemplate /> },
        { path: 'accounts/rfq/print/:id', element: <RFQTemplate /> },
        { path: 'accounts/purchase-order/print/:id', element: <PurchaseOrderTemplate /> },
        { path: 'accounts/invoices/print/saudi/:id', element: <SaudiInvoiceTemplate /> },
        { path: 'accounts/invoices/print/saudi-e/:id', element: <SaudiEInvoiceTemplate /> },
        { path: 'accounts/invoices/print/qatar/:id', element: <QatarInvoiceTemplate /> },
        { path: 'accounts/quotation/arabic/print/:id', element: <QuotationArabicTemplate /> },
        // { path: 'accounts/invoices/template', element: <InvoiceTemplate /> },
        { path: 'accounts/e-invoices/print/:id', element: <EInvoiceTemplate /> },
        // { path: 'accounts/qatar-invoices/template', element: <QatarInvoiceTemplate /> },
        { path: 'accounts/invoices/quotation/template', element: <QuotationTemplate /> },
        { path: 'accounts/invoices/saudi/invoice', element: <SaudiInvoiceTemplate /> },
        // { path: 'accounts/invoices/quotation/arabic/template', element: <QuotationArabicTemplate /> },
        { path: 'notifications', element: <NotificationPage /> },
        // { path: 'accounts/Payments/template', element: <PaymentTemplate /> },
        { path: "accounts/customer-payments/receipt/:id", element: <PaymentTemplate /> },




        { path: 'accounts/credit-notes', element: <CreditNote /> },
        { path: 'accounts/credit-notes/create', element: <CreateCreditNote /> },
        { path: 'accounts/credit-notes/details/:id', element: <CreateCreditNoteDetails /> },
        { path: 'accounts/credit-notes/print/saudi-e/:id', element: <SaudiECreditNote /> },
        { path: 'accounts/credit-notes/print/:id', element: <SaudiECreditNote /> },


        { path: 'accounts/configuration/chart-of-account', element: <ChartofAccounts /> },
        { path: 'accounts/configuration/chart-of-account/add', element: <AddChartOfAccounts /> },
        { path: 'accounts/configuration/chart-of-account/edit/:id', element: <EditChartOfAccounts /> },
        { path: 'accounts/configuration/chart-of-account/details/:id', element: <DetailChartOfAccounts /> },

        { path: 'accounts/configuration/currency', element: <Currency /> },
        { path: 'accounts/configuration/currency/add', element: <AddCurrency /> },
        { path: 'accounts/configuration/currency/edit/:id', element: <EditCurrency /> },
        { path: 'accounts/configuration/currency/details/:id', element: <CurrencyDetails /> },

        { path: 'accounts/configuration/journals', element: <Journals /> },
        { path: 'accounts/configuration/journals/add', element: <AddJournals /> },
        { path: 'accounts/configuration/journals/edit/:id', element: <EditJournals /> },
        { path: 'accounts/configuration/journals/details/:id', element: <DetailJournals /> },

        { path: 'accounts/configuration/taxes', element: <Taxes /> },
        { path: 'accounts/configuration/taxes/add', element: <AddTax /> },
        { path: 'accounts/configuration/taxes/edit/:id', element: <EditTax /> },
        { path: 'accounts/configuration/taxes/details/:id', element: <DetailTax /> },

        { path: 'accounts/configuration/accounting-settings', element: <AccountingSettings /> },
        { path: 'accounts/configuration/accounting-settings/edit', element: <EditAccountingSettings /> },
        { path: 'accounts/configuration/accounting-settings/edit/:id', element: <EditAccountingSettings /> },
        { path: 'accounts/financial-year/financial-year-lock', element: <FinancialYearLock /> },

        { path: 'accounts/customer-payments', element: <CustomerPayment /> },
        { path: 'accounts/customer-payments/add', element: <AddCustomerPayment /> },
        { path: 'accounts/customer-payments/details/:id', element: <CustomerPaymentDetails /> },

        { path: 'accounts/journal-entries', element: <JournalEntries /> },
        { path: 'accounts/journal-entries/add', element: <AddJournalEntries /> },
        { path: 'accounts/journal-entries/edit/:id', element: <EditJournalEntries /> },
        { path: 'accounts/journal-entries/details/:id', element: <DetailJournalEntries /> },
        { path: 'reports/', element: <Reports /> },
        { path: 'reports/trial-balance', element: <TrialBalance /> },
        { path: 'reports/aged-receivable', element: <AgedReceivable /> },
        { path: 'reports/aged-receivable/:customerId', element: <AgedReceivablesDetail /> },
        { path: 'reports/aged-payable-detail/:vendorId', element: <AgedPayablesDetail /> },
        { path: 'reports/sales-by-customer', element: <SalesByCustomer /> },
        { path: 'reports/sales-by-customer/:customer_id', element: <SalesByCustomerDetail /> },
        { path: 'reports/sales-by-item', element: <SalesByItem /> },
        { path: 'reports/sales-by-item/:item_id', element: <SalesByItemDetail /> },
        { path: 'reports/sales-summary', element: <SalesSummary /> },
        { path: 'reports/sales-by-sales-person', element: <SalesBySalesPerson /> },
        { path: 'reports/sales-by-sales-person-detail/:sales_person_uuid', element: <SalesBySalesPersonDetail /> },
        { path: 'reports/profit-by-item', element: <ProfitByItem /> },
        { path: 'reports/customer-outstanding', element: <CustomerOutstanding /> },
        { path: 'reports/collection-report', element: <CollectionReport /> },
        { path: 'reports/incentive-report', element: <IncentiveReport /> },
        { path: 'reports/target-vs-achievement', element: <TargetVsAchievementsReport /> },
        { path: 'reports/route-wise-sales', element: <RouteWiseReport /> },
        // { path: 'reports/aged-payable-detail', element: <AgedPayablesDetail /> },
        { path: 'reports/aged-payable', element: <AgedPayable /> },
        { path: 'reports/profit-and-loss', element: <ProfitAndLoss /> },
        { path: 'reports/balance-sheet', element: <BalanceSheet /> },
        { path: 'reports/purchase-by-item', element: <PurchasesByItem /> },
        { path: 'reports/purchase-by-vendor', element: <PurchasesByVendor /> },
        { path: 'reports/purchase-by-vendor/:vendor_id', element: <PurchasesByVendorDetail /> },
        { path: 'reports/purchase-by-item/:item_id', element: <PurchasesByItemDetail /> },
        { path: 'reports/tax-summary-report', element: <TaxSummaryReport /> },
        { path: 'reports/tax-summary-report-detail/:tax_id', element: <TaxSummaryReportDetail /> },
        { path: 'reports/inventory-valuation-summary', element: <InventoryValuationSummaryReport /> },
        { path: 'reports/inventory-valuation-summary-detail/:item_id', element: <InventoryValuationSummaryDetailReport /> },
        { path: 'reports/stock-summary', element: <StockSummaryReport /> },
        { path: 'reports/inventory-detail-summary', element: <InventoryDetailSummaryReport /> },
        { path: 'reports/stock-movement', element: <StockMovementReport /> },
        { path: 'reports/inventory-adjustment', element: <InventoryAdjustmentReport /> },
        { path: 'reports/activity-logs', element: <ActivityLogAuditTrailReport /> },

        { path: 'accounts/general-ledgers', element: <GeneralLedgers /> },
        { path: 'accounts/accounts-ledgers', element: <AccountLedgers /> },

        { path: 'accounts/debit-notes', element: <Refunds /> },
        { path: 'accounts/debit-notes/create', element: <CreateDebitNotes /> },
        { path: 'accounts/debit-notes/details/:id', element: <RefundDetails /> },

        { path: 'accounts/vendor-bills', element: <VendorBills /> },
        { path: 'accounts/vendor-bills/create', element: <CreateVendorBills /> },
        { path: 'accounts/vendor-bills/details/:id', element: <VendorBillDetails /> },


        { path: 'accounts/vendor-payments', element: <VendorPayments /> },
        { path: 'accounts/vendor-payments/details/:id', element: <VendorPaymentDetails /> },
        { path: 'accounts/vendor-payments/add', element: <AddVendorPayment /> },

        // Other Routes
        { path: 'loading', element: <ComingSoon /> },
        { path: 'error', element: <NoPermission /> },

        // Profile / Organization / User Accounts
        { path: 'my-profile', element: <MyProfile /> },
        { path: 'my-profile/edit', element: <MyProfileEdit /> },
        { path: 'my-organization', element: <MyOrganization /> },
        { path: 'my-organization/edit', element: <EditMyOrganization /> },
        { path: 'organization', element: <OrganizationDetails /> },
        { path: 'organization-details', element: <OrganizationDetails /> },
        { path: 'organization/edit', element: <OrganizationEdit /> },
        { path: 'user-accounts', element: <UserAccounts /> },
        { path: 'user-accounts/add', element: <AddUsers /> },
        { path: 'user-accounts/edit/:id', element: <EditUserAccount /> },
        { path: 'user-accounts/details/:id', element: <DetailsUserAccount /> },
        { path: 'user-roles', element: <UserRoles /> },
        { path: 'user-roles/details/:id', element: <UserRoleDetails /> },
        { path: 'user-roles/add', element: <UserRoleAdd /> },
        { path: 'user-roles/edit/:id', element: <UserRoleEdit /> },
        //Settings 
        { path: 'settings/prefix-numbering', element: <PrefixNumbering /> },

        { path: 'whatsapp/template', element: <WhatsappTemplate /> },
        { path: 'whatsapp/template/add', element: <AddWhatsappTemplate /> },
        { path: 'whatsapp/template/details/:id', element: <WhatsappTemplateDetails /> },
        { path: 'whatsapp/template/edit/:id', element: <WhatsappTemplateEdit /> },


        { path: 'whatsapp/message-history', element: <MessageHistory /> },
        { path: 'whatsapp/configuration', element: <WhatsappConfiguration /> },
        { path: 'whatsapp/configuration/add', element: <WhatsappConfigurationAdd /> },
        { path: 'whatsapp/configuration/edit/:id', element: <WhatsappConfigurationEdit /> },
        { path: 'whatsapp/configuration/details/:id', element: <WhatsappConfigurationDetails /> },



        //Routes

        { path: 'routes/',               element: <FeatureRoute feature="route_management"><RouteList /></FeatureRoute> },
        { path: 'routes/details/:id',    element: <FeatureRoute feature="route_management"><ViewRoutePage /></FeatureRoute> },
        { path: 'routes/add',            element: <FeatureRoute feature="route_management"><AddRoutePage /></FeatureRoute> },
        { path: 'routes/edit',           element: <FeatureRoute feature="route_management"><EditRoutePage /></FeatureRoute> },
        { path: 'routes/assign',         element: <FeatureRoute feature="route_management"><RouteAssignList /></FeatureRoute> },
        { path: 'routes/assign/add',     element: <FeatureRoute feature="route_management"><AddRouteAssign /></FeatureRoute> },
        { path: 'routes/assign/edit/:id',element: <FeatureRoute feature="route_management"><EditRouteAssign /></FeatureRoute> },
        { path: 'routes/assign/details/:id', element: <FeatureRoute feature="route_management"><RouteAssignDetails /></FeatureRoute> },
        { path: 'routes/history',        element: <FeatureRoute feature="route_management"><RouteHistoryList /></FeatureRoute> },
        { path: 'routes/history/details/:id', element: <FeatureRoute feature="route_management"><RouteHistoryDetail /></FeatureRoute> },
        { path: 'routes/live-tracking',  element: <FeatureRoute feature="route_management"><SalesmanLiveTracking /></FeatureRoute> },



        { path: 'import/first/', element: <ImportFirstPage /> },
        { path: 'import/second/', element: <ImportSecondPage /> },
        { path: 'import/third/', element: <ImportThirdPage /> },
        { path: 'import/fourth/', element: <ImportFourthPage /> },


      ],
    },
  ];
}



